import { SiteInfo } from "../../sites/shared/sites.entities";
import { VisitsController } from "../components/visits-tab/scripts/visits.controller";
import { Visit, VisitEvent } from "../components/visits-tab/scripts/visits.entities";
import { VisitLookup } from "../components/visits-tab/scripts/visits.lookup";
import { FilterSection, IFilteringParent } from "./data-completeness.filter";
import { DateUpdatedSection } from "../../../../shared/components/date-updated-section/date-updated-section.view";
import { Study } from "../../../../shared/entities/scripts/study";
import { Appendix } from "../../../../shared/entities/scripts/appendix";
import { Site } from "../../../../shared/entities/scripts/site";
import { OutcomesController } from "../components/outcomes-tab/scripts/outcomes.controller";
import { SetActiveTab } from "../../../../shared/scripts/tab-utilities";

import { AssessmentsController } from "../components/assessments-tab/scripts/assessments.controller";
import { Assessment, AssessmentEvent } from "../components/assessments-tab/scripts/assessments.entities";
import { AssessmentLookup } from "../components/assessments-tab/scripts/assessments.lookup";

declare var $: any;

export class DataCompletenessPage implements ISiteInfo, IFilteringParent {

    siteInfoList: SiteInfo[];
    siteInfoMap: Map<number, SiteInfo>;

    allStudies: Study[] = [];
    allAppendices: Appendix[] = [];
    allSites: Site[] = [];

    filter: FilterSection;

    selectedData: string; //visits, outcomes
    selectedView: string; //view-summary, view-tabular

    //going to try lazy loading data for different views in case assessments is large
    visitController: VisitsController = undefined;
    outcomeController: OutcomesController = undefined;
    assessmentController: AssessmentsController = undefined;

    constructor(visitTimingJson: any, siteInfoJson: any, lastUpdatedJson: any) {

        $(() => {
            new DateUpdatedSection(lastUpdatedJson, false, true, false);

            //console.log(visitTimingJson);
            //console.log(siteInfoJson);
            //console.log(assessmentsJson);
            //console.log(assessments2Json);

            this.siteInfoList = SiteInfo.Parse(siteInfoJson);
            this.siteInfoMap = new Map<number, SiteInfo>();
            this.siteInfoList.forEach((site: SiteInfo) => {
                if (!this.siteInfoMap.has(site.SiteNumber)) { this.siteInfoMap.set(site.SiteNumber, site); }
            });

            console.log(visitTimingJson);
            console.log(visitTimingJson[0]);
            this.visitController = new VisitsController(this, visitTimingJson);
            /*this.outcomeController = new OutcomesController(this, primaryOutcomesJson);
            this.assessmentController = new AssessmentsController(this, assessmentsJson);*/

            this.initializeFilters();

            this.selectedView = "view-summary";
            this.setTypeOfData("visits");
            
            this.FilterUpdated();

            $('#loading-indicator').hide();
            $('.loaded-content').removeClass('invisible');
        });
    }

    //FilterUpdated(studyIds: number[], appendixIds: number[], siteIds: number[], visitIds: number[]) {
    FilterUpdated() {
        
        if (this.selectedData == "visits") {
            this.visitController.FilterUpdated(this.filter.selectedStudyIds, this.filter.selectedAppendixIds, this.filter.selectedSiteIds, this.filter.selectedVisitIds, this.filter.selectedVisitRequiredIds);
        }
        else if (this.selectedData == "outcomes") {
            this.outcomeController.FilterUpdated(this.filter.selectedStudyIds, this.filter.selectedAppendixIds, this.filter.selectedSiteIds, this.filter.selectedOutcomeIds);
        }
        else if (this.selectedData == "assessments") {
            this.assessmentController.FilterUpdated(this.filter.selectedStudyIds, this.filter.selectedAppendixIds, this.filter.selectedSiteIds, this.filter.selectedVisitIds, this.filter.selectedAssessmentIds, this.filter.selectedTimepointIds);
        }
    }

    GetSiteName(siteNumber: number): string {
        return this.siteInfoMap.get(siteNumber).getSiteNameNumber();
    }

    initializeFilters(): void {
        let foundSiteIds: string[] = [];
        let foundStudyIds: number[] = [];
        let foundAppendixIds: number[] = [];

        //assumes visits is comprehensive list across data views
        this.visitController.allVisitEvents.forEach((v: VisitEvent) => {

            if (!foundSiteIds.includes(v.SiteNumber + "-" + v.StudyId)) { foundSiteIds.push(v.SiteNumber + "-" + v.StudyId); }
            if (!foundStudyIds.includes(v.StudyId)) {
                this.allStudies.push(new Study(v.StudyId, Study.GetStudyName(v.StudyId)));
                foundStudyIds.push(v.StudyId);
            }

            if (!foundAppendixIds.includes(v.AppendixId)) {
                this.allAppendices.push(new Appendix(v.AppendixId, v.StudyId, Appendix.GetAppendixName(v.AppendixId)));
                foundAppendixIds.push(v.AppendixId);
            }
        });

        let foundSiteMap: Map<number, Site> = new Map<number, Site>();
        this.siteInfoList.forEach((s: SiteInfo) => {
            if (foundSiteIds.includes(s.SiteNumber + "-" + s.StudyId)) {
                if (foundSiteMap.has(s.SiteNumber)) {
                    foundSiteMap.get(s.SiteNumber).StudyIds.push(s.StudyId);
                }
                else {
                    let newSite: Site = new Site(s.SiteNumber, s.getSiteNameNumber());
                    newSite.StudyIds.push(s.StudyId);
                    foundSiteMap.set(s.SiteNumber, newSite);
                }
            }
        });
        this.allSites = Array.from(foundSiteMap.values()).sort((a: Site, b: Site) => a.Name.localeCompare(b.Name));

        //this.filter = new FilterSection(this.allStudies, this.allAppendices, this.allSites, this.visitController.allVisits, this.visitController.allVisitRequired, this.outcomeController.allOutcomes, this.assessmentController.allAssessments, this.assessmentController.allTimepoints, this);
        this.filter = new FilterSection(this.allStudies, this.allAppendices, this.allSites, this.visitController.allVisits, this.visitController.allVisitRequired, [], [], [], this);
    }

    resetFilters(): void {
        this.filter.resetFilters();
    }

    setTypeOfData(newData: string): void {
        //console.log("setTypeOfData", newData);
        const $activeTab = $("#data-completeness-tabs .tab-pane.active");
        $("#loading-view-indicator").removeClass("invisible");
        //$("#data-completeness-tabs").empty();
        //$("#data-completeness-tabs").addClass("invisible");
        $activeTab.addClass("d-none");

        // Delay required to ensure that loading indicator shows before processing data
        setTimeout(async () => {
            this.selectedData = newData;
            if (this.selectedData == "visits") { SetActiveTab("data-completeness-tabs", "visits-tab"); this.setView(""); this.updateVisibleFilters(); }
            else if (this.selectedData == "outcomes") {
                if (this.outcomeController == undefined) {
                    let primaryOutcomesJson = JSON.parse(await this.getTabData(this.selectedData));
                    this.outcomeController = new OutcomesController(this, primaryOutcomesJson);
                    SetActiveTab("data-completeness-tabs", "outcomes-tab"); this.setView(""); this.updateVisibleFilters();
                    this.filter.refreshOutcomesFilters(this.outcomeController.allOutcomes);
                }
                else {
                    SetActiveTab("data-completeness-tabs", "outcomes-tab"); this.setView(""); this.updateVisibleFilters();
                }
            }
            else if (this.selectedData == "assessments") {
                if (this.assessmentController == undefined) {
                    let assessmentsJson = JSON.parse(await this.getTabData(this.selectedData));
                    this.assessmentController = new AssessmentsController(this, assessmentsJson);
                    SetActiveTab("data-completeness-tabs", "assessments-tab"); this.setView(""); this.updateVisibleFilters();
                    this.filter.refreshAssessmentsFilters(this.assessmentController.allAssessments, this.assessmentController.allTimepoints)
                }
                else {
                    SetActiveTab("data-completeness-tabs", "assessments-tab"); this.setView(""); this.updateVisibleFilters();
                }
            }

            this.FilterUpdated();

            $("#loading-view-indicator").addClass("invisible");
            //$("#data-completeness-tabs").removeClass("invisible");
            $activeTab.removeClass("d-none");
        }, 100);

    }

    setView(newView: string): void {

        //on data type change, stay on high-level tab, but reset to default view
        if (newView.length == 0) {
            if (this.selectedView.includes("summary")) { newView = "view-summary"; }
            else if (this.selectedView.includes("datatable")) { newView = "view-datatable"; }
        }

        //console.log("setView: ", newView, this.selectedData);

        this.selectedView = newView;

        if (this.selectedData == "visits") {
            this.visitController.setView(newView);
        }
        else if (this.selectedData == "outcomes") {
            this.outcomeController.setView(newView);
        }
        else if (this.selectedData == "assessments") {
            this.assessmentController.setView(newView);
        }
    }

    updateVisibleFilters(): void {

        if (this.selectedData == "visits") {
            $('#visit-filter').show();
            $('#timepoint-filter').hide();
            $('#visit-required-filter').show();
            $('#outcome-filter').hide();
            $('#assessment-filter').hide();
        }
        else if (this.selectedData == "outcomes") {
            $('#visit-filter').hide();
            $('#timepoint-filter').hide();
            $('#visit-required-filter').hide();
            $('#outcome-filter').show();
            $('#assessment-filter').hide();

        } else if (this.selectedData == "assessments") {
            $('#visit-filter').hide();
            $('#timepoint-filter').show();
            $('#visit-required-filter').hide();
            $('#outcome-filter').hide();
            $('#assessment-filter').show();
        }

        // if (this.selectedData === "visits" || this.selectedData === "assessments") {
        //     $('#visit-filter').show();
        //     $('#visit-required-filter').show();
        //     $('#outcome-filter').hide();
        // } else if (this.selectedData === "outcomes") {
        //     $('#visit-filter').hide();
        //     $('#visit-required-filter').hide();
        //     $('#outcome-filter').show();
        // }
    }

   /* exportTable(): void {
        if (this.selectedView == "visits") {
            this.visitController.exportTable();
        }
        else if (this.selectedView == "outcomes") {
            this.outcomeController.exportTable();
        }
        else if (this.selectedView == "assessments") {
            this.assessmentController.exportTable();
        }
    }*/

    async getTabData(dataName: string): Promise<any> {
        let postName = "";
        if (dataName == "visits") postName = "visit-timing";
        if (dataName == "outcomes") postName = "primary-outcomes";
        if (dataName == "assessments") postName = "assessments";

        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: `/secure/reporting/data-completeness/data-completeness?handler=UpdateView`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: postName },
                dataType: "json"
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }
}

export interface ISiteInfo {
    siteInfoList: SiteInfo[];
    GetSiteName(siteNumber: number): string;
}